export default __webpack_public_path__ + "static/media/123.db87f542.svg";